import { BookOutlined } from '@ant-design/icons';

const SavedViewsEmptyState = ({ className = 'px-3' }: { className?: string }) => (
    <div className={`flex flex-col items-center gap-[14px] text-center ${className}`}>
        <BookOutlined className="text-[20px] text-fontColor/45" />
        <div className="flex flex-col items-center gap-[6px]">
            <div className="text-[14px] font-medium leading-[16px] text-[#18181b]">No saved views yet</div>
            <div className="text-[12px] leading-[16px] text-[#71717b]">
                Save your current configuration for quick access
            </div>
        </div>
    </div>
);

export default SavedViewsEmptyState;
